<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">-->

<div class="page-container custom-page-background position-absolute">
  <div class="login-page">

    <div class="login-form">
      <div class="login-form-container">
        <div class="header">
          <div class="hass-logo" style=" max-width: 270px; margin: 0 auto;">
            <img src="/src/assets/images/HASSLogo.png" />
          </div>

          <p>where <strong>excellent hearing</strong> begins</p>
        </div>

        <div class="sub-header">
          <h2>Login</h2>
          <p>Don't have an account? <a [href]="mailtoLink">Contact Administrator</a></p>
        </div>


        <form #f="ngForm" class="form" (submit)="formSubmit(f)">

          <div class="form-group column align-start">
            <label style="font-size: 18px !important;">Email Address</label>
            <input type="text" class="form-control form-control-lg" [(ngModel)]="user.UserName" #UserNameCtrl="ngModel" name="UserName" required />
            <div *ngIf="submitted && UserNameCtrl.invalid" class="invalid-feedback">
              <div *ngIf="UserNameCtrl.errors?.['required']">
                <i class="fas fa-exclamation-circle"></i> Username is required
              </div>
            </div>
          </div>

          <div class="form-group column align-start">
            <label style="font-size: 18px !important;">Password</label>
            <input type="password" class="form-control form-control-lg" [(ngModel)]="user.Password" #PasswordCtrl="ngModel" name="Password" required />
            <div *ngIf="submitted && PasswordCtrl.invalid" class="invalid-feedback">
              <div *ngIf="PasswordCtrl.errors?.['required']">
                <i class="fas fa-exclamation-circle"></i> Password is required
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-checkbox">
              <label for="remember_me_checkbox" class="checkbox-control" style="cursor: pointer;">
                Remember Me
                <input type="checkbox" id="remember_me_checkbox" [(ngModel)]="user.RememberMe" [ngModelOptions]="{standalone: true}" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </div>
          </div>

          <button type="submit" [disabled]="loading" class="custom-btn" style=" max-width: none;">
            <span *ngIf="!loading">Log in</span>
            <span *ngIf="loading">LOADING...</span>
          </button>

          <div style="width: 100%">
            <a class="forgot-password" (click)="forgotPassword()">Forgot your password?</a>
          </div>

        </form>

        <div class="form-footer">
          <div>
            <p><small>Copy &copy;2024 H.A.S.S Ear Institute</small></p>
            <!--<small><a style="margin-right: 10px">Term of Service</a> |-->
            <small><a style="margin-left: 10px">Privacy Policy</a></small>
          </div>

        </div>
      </div>

    </div>

    <div class="login-banner" style="text-align: left;">

      <div class="banner-container">

        <div class="hass-logo">
          <img src="/src/assets/images/HASSLogo.png" />
        </div>

        <h2><strong>Ear</strong>buzz</h2>
      </div>

    </div>

  </div>
</div>
